import { connect } from "react-redux";
import { compose } from "recompose";
import EquipmentsForm from "components/Equipments/EquipmentsForm";
import { createEquipment } from "actions/equipments/equipmentsActions";
import * as routes from "constants/routes";

const handleFormSubmit = props => formValues => {
  return props.createEquipment(formValues).then(() => {
    props.history.push(routes.EQUIPMENTS);
  });
};

const mapStateToProps = ({ equipments }, ownProps) => {
  const { error } = equipments;
  const initialValues = {};
  return {
    initialValues: initialValues,
    error: error,
    onSubmit: handleFormSubmit(ownProps),
    isEditing: false
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createEquipment: formValues => dispatch(createEquipment(formValues))
  };
};

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
  connect(mapStateToProps)
)(EquipmentsForm);
